import ApiService from './api.service'
const PREFIX = '/booking'
const PREFIX_ITEM = '/booking-item'

const BookingService = {
	deleteBookingDocById: function (docId) {
		return ApiService.delete(`${PREFIX}/delete/${docId}`);
	},
	convertBookingToSale: function (bookingDoc) {
		return ApiService.post(`${PREFIX}/convert-booking`, bookingDoc);
	},
	getBookingItemsByDocId: function (doc_id) {
		return ApiService.get(`${PREFIX_ITEM}/get/${doc_id}`);
	},
	getBookingDocById: function (doc_id) {
		return ApiService.get(`${PREFIX}/get/${doc_id}`);
	},
	suspendBookingDoc: function (payload) {
		return ApiService.post(`${PREFIX}/suspend`, payload);
	},
	saveBookingDoc: function (payload) {
		return ApiService.post(`${PREFIX}/save`, payload);
	},
	createBookingDoc: function (payload) {
		return ApiService.post(`${PREFIX}/create`, payload);
	},
	fetchBookingDocs: function (payload) {
		return ApiService.post(`${PREFIX}/list`, payload);
	}
};

export default BookingService;
